<ng-template #template let-row="row">
  <div class="no-select">
    {{ row?.created ? (row.created | dateTimeFormat) : '-' }}
  </div>
</ng-template>
